<template>
  <payment-concept-list :concept-type="type" />
</template>
    
<script>
import PaymentConceptList, {
  PaymentConceptType,
} from "../components/PaymentConceptList.vue";

export default {
  name: "concepts-list-view",
  components: { PaymentConceptList },
  data() {
    return {
      type: PaymentConceptType.concept,
    };
  },
};
</script>